// fetch() only rejects on network failure, never on HTTP error statuses (4xx/5xx),
// so callers checking only .catch() report success on a failed request.
export default function fetchOk(url, options) {
  return fetch(url, options).then((res) => {
    if (!res.ok) {
      throw new Error(`Request to ${url} failed with status ${res.status}`);
    }
    return res;
  });
}
